var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2047 5.35775C16.5008 3.54741 13.6237 3.54742 11.9198 5.35776L6.17291 11.4638C5.41951 12.2643 5 13.3222 5 14.4214V21.3166C5 23.5954 6.77182 25.4814 9.04614 25.6236L15.0691 26L21.0901 25.6237C23.3654 25.4815 25.1376 23.5939 25.1363 21.3142L25.1321 14.427C25.1315 13.3286 24.712 12.2718 23.9592 11.472L18.2047 5.35775ZM14.9186 16.4591C15.0109 16.4024 15.1273 16.4024 15.2196 16.4591L17.5211 17.8723C17.6064 17.9246 17.6583 18.0174 17.6583 18.1174V21.1076C17.6583 21.5843 18.0447 21.9707 18.5214 21.9707C18.998 21.9707 19.3844 21.5843 19.3844 21.1076V18.1174C19.3844 17.4174 19.0209 16.7676 18.4244 16.4013L16.1229 14.9881C15.4764 14.5912 14.6618 14.5912 14.0153 14.9881L11.7138 16.4013C11.1173 16.7676 10.7538 17.4174 10.7538 18.1174V21.1076C10.7538 21.5843 11.1402 21.9707 11.6168 21.9707C12.0935 21.9707 12.4799 21.5843 12.4799 21.1076V18.1174C12.4799 18.0174 12.5318 17.9246 12.6171 17.8723L14.9186 16.4591Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.927b0ba0daeb301396175e4fa0a115a2.svg";
export { ForwardRef as ReactComponent };